interface IconProps {
  className?: string;
}

export function ExpandIcon({ className }: IconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M4 8V4h4m8 0h4v4m0 8v4h-4m-8 0H4v-4"
      />
    </svg>
  );
}
